import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  persons: [],
  totalElements: 0,
  createdId: null,
  createdAddressId: null,
  savedEmail: '',
});

const { Types, Creators } = createActions({
  getPersonsRequest: ['customerId', 'pageParams'],
  getPersonsRequestSuccess: ['persons', 'totalElements'],
  getPersonsRequestFailure: ['errorMessage'],

  createPersonRequest: ['personInfos', 'customerId', 'pageParams'],
  createPersonRequestSuccess: ['createdId', 'createdAddressId', 'savedEmail', 'persons', 'totalElements', 'successMessage'],
  createPersonRequestFailure: ['errorMessage'],

  editPersonRequest: ['personInfos'],
  editPersonRequestSuccess: ['updatedPerson', 'savedEmail', 'successMessage'],
  editPersonRequestFailure: ['errorMessage'],

  deletePersonRequest: ['personId', 'customerId', 'pageParams'],
  deletePersonRequestSuccess: ['persons', 'totalElements', 'successMessage'],
  deletePersonRequestFailure: ['errorMessage'],

  resetPersons: null,
});

export const getPersonsRequest = (state) => state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const getPersonsRequestSuccess = (state, { persons, totalElements }) =>
  state.merge({ isLoading: false, persons, totalElements });
export const getPersonsRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const createPersonRequest = (state) =>
  state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const createPersonRequestSuccess = (
  state,
  { createdId, createdAddressId, savedEmail, persons, totalElements, successMessage },
) => state.merge({ isLoading: false, createdId, createdAddressId, savedEmail, persons, totalElements, successMessage });
export const createPersonRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const editPersonRequest = (state) => state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const editPersonRequestSuccess = (state, { updatedPerson, savedEmail, successMessage }) => {
  const newPersons = state.persons.map((person) => {
    if (person.personId !== updatedPerson.personId) {
      return person;
    } else {
      return updatedPerson;
    }
  });
  return state.merge({ isLoading: false, persons: newPersons, savedEmail, successMessage });
};
export const editPersonRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const deletePersonRequest = (state) =>
  state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const deletePersonRequestSuccess = (state, { persons, totalElements, successMessage }) =>
  state.merge({ isLoading: false, persons, totalElements, successMessage });
export const deletePersonRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const resetPersons = (state) => state.merge({ persons: [], totalElements: 0 });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_PERSONS_REQUEST]: getPersonsRequest,
  [Types.GET_PERSONS_REQUEST_SUCCESS]: getPersonsRequestSuccess,
  [Types.GET_PERSONS_REQUEST_FAILURE]: getPersonsRequestFailure,

  [Types.CREATE_PERSON_REQUEST]: createPersonRequest,
  [Types.CREATE_PERSON_REQUEST_SUCCESS]: createPersonRequestSuccess,
  [Types.CREATE_PERSON_REQUEST_FAILURE]: createPersonRequestFailure,

  [Types.EDIT_PERSON_REQUEST]: editPersonRequest,
  [Types.EDIT_PERSON_REQUEST_SUCCESS]: editPersonRequestSuccess,
  [Types.EDIT_PERSON_REQUEST_FAILURE]: editPersonRequestFailure,

  [Types.DELETE_PERSON_REQUEST]: deletePersonRequest,
  [Types.DELETE_PERSON_REQUEST_SUCCESS]: deletePersonRequestSuccess,
  [Types.DELETE_PERSON_REQUEST_FAILURE]: deletePersonRequestFailure,

  [Types.RESET_PERSONS]: resetPersons,
});

export const PersonsTypes = Types;
export default Creators;
